import "core-js/modules/es.error.cause.js";
import { mapMutations, mapState } from "vuex";
import request from "@/service/invite";
import invite from "@/service/invite";
import { mobileVerificationCode, emailVerificationCode } from "@/service/user";
import { separateNames } from "@/utils/separate-names";
import { changeI18nLanguage } from "@/utils/util";
/* eslint-disable*/
import AreaPhoneInput from "@/components/Common/AreaPhoneInput.vue";
import FootLanguage from "@/components/Layout/footLanguage.vue";
export default {
  props: {
    consumeInviteInfo: {
      type: Object,
      default: () => {}
    },
    inviteDeatilInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false,
      scene: "phone",
      inviteInfo: {
        unitName: "",
        userName: "",
        account: "",
        mobile: "",
        email: "",
        captcha: "",
        mobileAreaCode: "+86"
      },
      time: 60,
      counter: null,
      sceneMap: {
        phone: {
          title: $t("haa72", "手机"),
          tip: $t("7ji3y96", "请输入手机号"),
          fetch: mobileVerificationCode
        },
        email: {
          title: $t("padf2", "邮箱"),
          tip: $t("2j0utw5", "请输入邮箱"),
          fetch: emailVerificationCode
        }
      },
      rules: {
        captcha: [{
          required: true,
          trigger: "blur,change",
          validator: this.validateCaptcha
        }],
        userName: [{
          required: true,
          trigger: "blur,change",
          validator: this.validateUserName
        }],
        account: [{
          required: true,
          trigger: "blur,change",
          validator: this.validateAccount
        }]
      }
    };
  },
  computed: {
    ...mapState({
      language: state => state.app.language
    }),
    unitName() {
      return this.consumeInviteInfo.unitName;
    },
    tip() {
      let {
        unitName,
        createUserName
      } = this.inviteDeatilInfo;
      return `<p class="break-all">${createUserName}${$t('28x0qyv', '<span class="px-1">邀请您加入</span>')}${unitName}</p>`;
    },
    sceneData() {
      return this.sceneMap[this.scene];
    },
    buttonText() {
      return this.counter ? `${$t('f7b6hy5', '重新获取(')}${this.time})` : $t("t09mz15", "获取验证码");
    },
    showPrepend() {
      return this.scene === "phone";
    },
    regMap() {
      return {
        phone: {
          reg: /^[0-9 || *]{1,11}$/,
          msg: $t("w8axw89", "请输入正确的手机号")
        },
        email: {
          reg: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          msg: $t("venleq7", "邮箱格式不正确")
        }
      };
    }
  },
  methods: {
    ...mapMutations(["setLanguage"]),
    changeAccountType() {
      this.inviteInfo.account = "";
      this.inviteInfo.captcha = "";
      this.time = 60;
      clearInterval(this.counter);
      this.$refs.form.validateField("account");
      this.counter = null;
    },
    toLowerCase(event) {
      let {
        value
      } = event.target;
      this.inviteInfo.account = value.toLowerCase();
    },
    validateAccount(rules, value, callback) {
      let accountReg = this.regMap[this.scene];
      if (accountReg.reg.test(value)) {
        callback();
      } else {
        callback(new Error(accountReg.msg));
      }
    },
    validateUserName(rules, value, callback) {
      if (/^[a-zA-Z0-9\u4e00-\u9fa5\s+/\\.,;:!?[()\]\\{}_\-\\$€£#@*+&~ ]{2,120}$/.test(value)) {
        callback();
      } else {
        callback(new Error($t("qwti1bj", "仅2-120字母，数字，汉字和部分符号")));
      }
    },
    validateCaptcha(rules, value, callback) {
      if (value.length === 6) {
        callback();
      } else {
        callback(new Error($t("xiy1hw8", "请输入6位验证码")));
      }
    },
    async handleClick() {
      this.counter ? null : this.getCaptcha();
    },
    setCounter() {
      this.counter = setInterval(() => {
        this.time--;
        if (this.time <= 0) {
          clearInterval(this.counter);
          this.counter = null;
          this.time = 60;
        }
      }, 1000);
    },
    async initializeLanguage(lang) {
      // 邀请链接中的语言只在页面初始化时应用，后续切换交由公共语言组件处理。
      const languageCode = await changeI18nLanguage(lang);
      if (!languageCode) return;
      this.setLanguage(languageCode);
    },
    handleLanguageChange() {
      // 与页面原有切换行为一致，重置表单并清除旧语种的校验提示。
      this.$refs.form.resetFields();
    },
    async getCaptcha() {
      let valid1 = null;
      let valid2 = null;
      await this.$refs.form.validateField("userName", valid => valid1 = !valid);
      await this.$refs.form.validateField("account", valid => valid2 = !valid);
      if (valid1 && valid2) {
        let {
          inviteCode
        } = this.$route.query;
        let {
          userName,
          account,
          mobileAreaCode
        } = this.inviteInfo;
        let data = {
          inviteCode: inviteCode,
          name: userName,
          mobile: this.scene === "phone" ? account : null,
          email: this.scene === "phone" ? null : account,
          mobileAreaCode
        };
        let {
          data: {
            result,
            msg
          }
        } = await request.sendVerificationCode(data);
        if (result === 0) {
          this.$Message.success(msg);
          this.setCounter();
        }
      }
    },
    async activeAccount() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.submit();
        }
      });
    },
    async submit() {
      let {
        inviteCode
      } = this.$route.query;
      let {
        userName,
        account,
        captcha,
        mobileAreaCode
      } = this.inviteInfo;
      let [userSurname, userGivenName] = separateNames(userName);
      let params = {
        inviteCode,
        name: userName,
        mobile: this.scene === "phone" ? account : null,
        email: this.scene === "phone" ? null : account,
        verificationCode: captcha,
        userSurname,
        userGivenName,
        mobileAreaCode
      };
      this.loading = true;
      let {
        data: {
          result,
          msg
        }
      } = await invite.consumeInviteLink(params);
      this.loading = false;
      if (result === 0) {
        let {
          needApprove
        } = this.inviteDeatilInfo;
        this.$emit("next", needApprove === "F");
        if (result === 0) {
          this.$Message.success(msg);
        }
      } else if (result === 30008) {
        this.$emit("next", true);
      }
    },
    back() {
      this.$emit("back", "activateAccount");
    }
  },
  watch: {
    "this.inviteInfo": function (val) {
      console.log(val);
    }
  },
  async mounted() {
    let {
      lang
    } = this.$route.query;
    if (lang) {
      await this.initializeLanguage(lang);
    }
  },
  components: {
    AreaPhoneInput,
    FootLanguage
  }
};